/* Progressive enhancement only: no cart requests, timers or hidden content. */
(() => {
  if (window.__sauveInteractions) return;
  window.__sauveInteractions = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  const seen = new WeakSet();
  // Do not move purchase controls, links or form fields while people tap them.
  const targets = '.sv-section-head h2,.sp-selection .sp-section-heading h2,.sv-stone img,.sv-edit__copy h2,.sv-gift__copy h2,.sp-product-detail__header h2,.sp-product-detail__photo img,.sp-product-detail__specification h3';
  function animate(element, frames, options) {
    if (reduced.matches || typeof element.animate !== 'function') return;
    const animation = element.animate(frames, options);
    active.add(animation);
    animation.finished.catch(() => {}).finally(() => active.delete(animation));
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (entry.target.isConnected) animate(entry.target,
        [{ opacity: .86, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 360, easing: 'cubic-bezier(.2,.65,.3,1)' });
    }
  }, { threshold: .08, rootMargin: '0px 0px -20px 0px' }) : null;
  function enhance(root) {
    if (!observer || reduced.matches || document.body.classList.contains('sauve-studio')) return;
    root.querySelectorAll(targets).forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      // Above-the-fold content paints immediately, including the LCP image.
      if (element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
    });
  }
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(targets).forEach(element => observer?.unobserve(element));
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      active.forEach(animation => animation.cancel());
      observer?.disconnect();
    } else enhance(document);
  });

  let dialog, opener;
  function getDialog() {
    if (dialog) return dialog;
    if (!('HTMLDialogElement' in window) || typeof HTMLDialogElement.prototype.showModal !== 'function') return null;
    dialog = document.createElement('dialog');
    dialog.className = 'sv-image-dialog';
    dialog.setAttribute('aria-label', 'Fotografía de la joya ampliada');
    dialog.innerHTML = '<div class="sv-image-dialog__surface"><header><span data-sv-image-title></span><button type="button" autofocus aria-label="Cerrar fotografía ampliada">Cerrar <span aria-hidden="true">×</span></button></header><img alt=""><p role="status" data-sv-image-status></p><a data-sv-image-original>Abrir imagen original <svg class="sv-ui-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="display:inline-block;width:18px;height:18px;vertical-align:middle;flex:0 0 18px;fill:none;stroke:currentColor"><path d="M6 18 18 6M6 6h12v12"/></svg></a></div>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      const image = dialog.querySelector('img');
      image.onload = null; image.onerror = null; image.removeAttribute('src');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    return dialog;
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[data-sv-zoom]') : null;
    if (!link || !/^https?:$/.test(new URL(link.href).protocol)) return;
    const panel = getDialog();
    if (!panel) return; // The ordinary image link remains usable without enhancement.
    event.preventDefault();
    opener = link;
    const image = panel.querySelector('img');
    const status = panel.querySelector('[data-sv-image-status]');
    const label = link.querySelector('img')?.alt || 'Fotografía de Sauvé';
    panel.querySelector('[data-sv-image-title]').textContent = label;
    panel.querySelector('[data-sv-image-original]').href = link.href;
    image.alt = label;
    status.textContent = 'Cargando fotografía…';
    image.onload = () => { status.textContent = ''; };
    image.onerror = () => { status.textContent = 'No pudimos cargar la fotografía. Puedes abrir la imagen original o volver a la pieza.'; };
    image.src = link.href;
    if (!panel.open) panel.showModal();
    animate(panel.querySelector('.sv-image-dialog__surface'),
      [{ opacity: .9, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }],
      { duration: 180, easing: 'ease-out' });
  });
})();
